import React, { Component } from "react";
import * as Http from "../../../http";
import { ProgressBar, MenuItem, DropdownButton, Table } from "react-bootstrap";
import * as Business from "../../../utils/business";
import { ErrorCode } from "../../../const";
import { Field, reduxForm } from "redux-form";
import renderField from "components/FormInputs/renderField";
import UploadSelectedFilesPanel from "../../../components/UploadSelectedFilesPanel";
import { FileExtension } from "../../../const";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

const chunkSize = 1048576 * 3;
let lstInterval = [];

function clearGetBatchUploadInterval(reportName) {
  lstInterval.forEach((id) => {
    clearInterval(id);
    console.warn(`${reportName} | Received state: STOP`);
  });
}

function convertReportName(reportName) {
  return `LR_NSFR_${reportName}`;
}

const dicSingleConsol = {
  single: "SINGLE",
  consol: "CONSOL",
};

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progressValue: 0,
      errorCode: null,

      singleConsol: "single",
      fileExtension: FileExtension.XLSX,
      isMultipleFile: false,
      fileAccept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
      reportName: "",
      reportDate: null,
      noFileVal: "No file chosen...",
      classFileUpload: "file-upload",
      isDragging: false,

      totalFiles: 0,
      listFileNameSelected: [],
      allSelectedFiles: [],
      uploadFileStates: {},
      dicFileToBeUpload: {},
      isUploadOnly: false,
      isUploadAndMerge: false,
      isCalculateOnly: false,
      isUploadOnlySuccessful: false,
      isUploadAndMergeSuccessful: false,
      validateErrors: [],
      currentStage: "idle",
      validationProgress: 0,
      autoNavigateCountdown: null,
    };
    this.setFileExtensionSelected = this.setFileExtensionSelected.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.onUploadFile = this.onUploadFile.bind(this);
    this.onUploadFileAndMergeData = this.onUploadFileAndMergeData.bind(this);
    this.onUploadChunkFile = this.onUploadChunkFile.bind(this);
    this.onUploadChunkFileComplete = this.onUploadChunkFileComplete.bind(this);
    this.onGetBatchUploadingResponse =
      this.onGetBatchUploadingResponse.bind(this);

    this.handleUploadFileResponse = this.handleUploadFileResponse.bind(this);
    this.renderProgress = this.renderProgress.bind(this);
    this.renderUploadOnlySuccessful =
      this.renderUploadOnlySuccessful.bind(this);

    this._validationTimer = null;
    this._autoNavigateTimer = null;
  }

  componentWillUnmount() {
    if (this._validationTimer) clearInterval(this._validationTimer);
    if (this._autoNavigateTimer) clearInterval(this._autoNavigateTimer);
  }

  setUploadFileState = (fileName, status) => {
    this.setState((prev) => ({
      uploadFileStates: {
        ...prev.uploadFileStates,
        [fileName]: status,
      },
    }));
  };

  startValidationStage = () => {
    if (this._validationTimer) clearInterval(this._validationTimer);
    this.setState({ currentStage: "validating", validationProgress: 3 });
    this._validationTimer = setInterval(() => {
      this.setState((prev) => {
        const next = Math.min(prev.validationProgress + 12, 100);
        if (next >= 100) {
          clearInterval(this._validationTimer);
          this._validationTimer = null;
          this.startAutoNavigateToFileManagement();
          return {
            validationProgress: 100,
            currentStage: "validated",
          };
        }
        return { validationProgress: next };
      });
    }, 240);
  };

  startAutoNavigateToFileManagement = () => {
    let countdown = 3;
    this.setState({ autoNavigateCountdown: countdown });
    if (this._autoNavigateTimer) clearInterval(this._autoNavigateTimer);
    this._autoNavigateTimer = setInterval(() => {
      countdown -= 1;
      if (countdown <= 0) {
        clearInterval(this._autoNavigateTimer);
        this._autoNavigateTimer = null;
        this.props.history.push("/liquidity-ratio/nfsr/file-management");
      } else {
        this.setState({ autoNavigateCountdown: countdown });
      }
    }, 1000);
  };

  onChangeFile = (e) => {
    const target = e.target;
    const filename = target ? target.value : "";
    let classFileUpload = "file-upload";
    let noFileVal = "No file chosen...";

    if (/^\s*$/.test(filename)) {
      classFileUpload = "file-upload";
      noFileVal = "No file chosen...";
    } else {
      classFileUpload = "file-upload active";
      noFileVal = filename.replace("C:\\fakepath\\", "");
    }

    this.setState({ classFileUpload, noFileVal }, () => {
      const dicFileToBeUpload = {};
      const listFileNameSelected = [];
      const uploadFileStates = {};
      let totalFiles = 0;
      if (target.files) {
        for (let index in target.files) {
          if (new RegExp(/^\d+$/).test(index)) {
            const file = target.files[index];
            const totalCount =
              file.size % chunkSize === 0
                ? file.size / chunkSize
                : Math.floor(file.size / chunkSize) + 1; // Total count of chunks will have been upload to finish the file
            const fileID = uuidv4() + "." + file.name.split(".").pop();
            dicFileToBeUpload[file.name] = {
              counter: 1,
              fileName: file.name,
              fileToBeUpload: file,
              beginingOfTheChunk: 0,
              endOfTheChunk: chunkSize,
              fileGuid: fileID,
              fileSize: file.size,
              chunkCount: totalCount > 0 ? totalCount : 1,
              isUploaded: false,
            };
            listFileNameSelected.push(file.name);
            uploadFileStates[file.name] = "pending";
            totalFiles++;
          }
        }
        if (totalFiles === 1) {
          noFileVal = listFileNameSelected[0];
          classFileUpload = "file-upload active";
        }
        if (totalFiles > 1) {
          noFileVal = `${totalFiles} files chosen`;
        }
      }
      this.setState({
        classFileUpload,
        listFileNameSelected,
        allSelectedFiles: [...listFileNameSelected],
        uploadFileStates,
        dicFileToBeUpload,
        noFileVal,
        totalFiles,
        validateErrors: [],
        currentStage: "idle",
        validationProgress: 0,
        autoNavigateCountdown: null,
      });
    });
  };

  onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: false });
    if (this.state.progressValue > 0) return;
    const files = e.dataTransfer ? e.dataTransfer.files : null;
    this.onChangeFile({ target: { files, value: "dropped" } });
  };

  getCurrentFileUploadingInfo = () => {
    const { fileUploading, dicFileToBeUpload } = this.state;
    const fileUploadingInfo = dicFileToBeUpload.hasOwnProperty(fileUploading)
      ? dicFileToBeUpload[fileUploading]
      : {};
    return fileUploadingInfo;
  };

  updateDicFileToBeUpload = (fileName, data, cb) => {
    const dicFileToBeUpload = this.state.dicFileToBeUpload;
    if (dicFileToBeUpload.hasOwnProperty(fileName)) {
      dicFileToBeUpload[fileName] = { ...dicFileToBeUpload[fileName], data };
    }
    this.setState({ dicFileToBeUpload }, () => {
      cb && cb();
    });
  };

  onUploadChunkFile = () => {
    try {
      let fileUploadingInfo = this.getCurrentFileUploadingInfo();
      const fileUploading = this.state.fileUploading;
      const currentCounter = fileUploadingInfo.counter;
      fileUploadingInfo["counter"] = currentCounter + 1;

      this.updateDicFileToBeUpload(
        fileUploading,
        fileUploadingInfo,
        async () => {
          this.setUploadFileState(fileUploading, "uploading");
          fileUploadingInfo = this.getCurrentFileUploadingInfo();
          const {
            fileGuid,
            chunkCount,
            fileToBeUpload,
            beginingOfTheChunk,
            endOfTheChunk,
          } = fileUploadingInfo;

          if (currentCounter <= chunkCount) {
            const chunk = fileToBeUpload.slice(
              beginingOfTheChunk,
              endOfTheChunk,
            );

            Http.uploadChuckFile(chunk, {
              id: currentCounter,
              fileName: fileGuid,
            }).then(async (response) => {
              const isSuccess = response ? response.Success : false;
              if (isSuccess) {
                fileUploadingInfo["beginingOfTheChunk"] = endOfTheChunk;
                fileUploadingInfo["endOfTheChunk"] = endOfTheChunk + chunkSize;
                this.updateDicFileToBeUpload(
                  fileUploading,
                  fileUploadingInfo,
                  async () => {
                    fileUploadingInfo = this.getCurrentFileUploadingInfo();
                    if (currentCounter == chunkCount) {
                      fileUploadingInfo["isUploaded"] = true;
                      this.updateDicFileToBeUpload(
                        fileUploading,
                        fileUploadingInfo,
                        async () => {
                          let isAllFilesUploaded = true;
                          for (let fileName in this.state.dicFileToBeUpload) {
                            if (
                              this.state.dicFileToBeUpload[fileName][
                                "isUploaded"
                              ] === false
                            ) {
                              isAllFilesUploaded = false;
                              break;
                            }
                          }
                          console.warn(
                            `The file upload is completed. Counter: ${currentCounter}, OriginFile: ${fileToBeUpload.name}, FileId: ${fileGuid}`,
                          );
                          await this.onUploadChunkFileComplete(
                            isAllFilesUploaded,
                          );
                        },
                      );
                    } else {
                      var percentage =
                        this.state.progressValue /
                          Object.keys(this.state.dicFileToBeUpload).length +
                        (currentCounter / chunkCount) * 100;
                      if (percentage > 99) percentage = 100;
                      console.warn(
                        `'The file is uploading. Counter ${currentCounter}, OriginFile: ${fileToBeUpload.name}, FileId: ${fileGuid}`,
                      );
                      this.setState({ progressValue: percentage }, () => {
                        this.onUploadChunkFile();
                      });
                    }
                  },
                );
              } else {
                console.error("Error Occurred:", response.ErrorCode);
                await this.handleUploadFileResponse(response);
              }
            });
          }
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  onUploadChunkFileComplete = async (isAllFilesUploaded) => {
    const {
      reportName,
      reportDate,
      fileExtension,
      isUploadAndMerge,
      isUploadOnly,
      isUploadAndMergeSuccessful,
      isCalculateOnly,
      singleConsol,
    } = this.state;
    let fileUploadingInfo = this.getCurrentFileUploadingInfo();
    const { fileToBeUpload, fileGuid } = fileUploadingInfo;
    if (fileToBeUpload && fileToBeUpload.name) {
      this.setUploadFileState(fileToBeUpload.name, "uploaded");
    }

    Http.uploadChuckFileComplete(
      fileGuid,
      {
        originFileName: fileToBeUpload ? fileToBeUpload.name : fileGuid,
        fileGuid: fileGuid,
        reportName: convertReportName(reportName),
        reportDate: reportDate,
        isAllFilesUploaded,
        fileExtension,
        singleConsol,

        isUploadOnly: isUploadOnly.toString(),
        isUploadAndMerge: isUploadAndMerge.toString(),
        isCalculateOnly: isCalculateOnly.toString(),
      },
      Business.COMPONENT.NSFR,
    ).then((res) => {
      if (res && res.ErrorCode == ErrorCode.PendingUpload) {
        let { listFileNameSelected } = this.state;
        const fileUploading = listFileNameSelected.shift();
        this.setState({ fileUploading, listFileNameSelected }, () => {
          this.setUploadFileState(fileUploading, "uploading");
          this.onUploadChunkFile();
        });
      } else {
        this.setState({ progressValue: 100 }, () => {
          this.handleUploadFileResponse(res);
          this.onGetBatchUploadingResponse();
        });
      }
    });
  };

  onUploadFile = () => {
    this.setState(
      { hasResult: false, progressValue: 5, currentStage: "uploading" },
      () => {
        if (this.state.isCalculateOnly) {
          this.onUploadChunkFileComplete(true);
          return;
        }
        let { listFileNameSelected } = this.state;
        const fileUploading = listFileNameSelected.shift();
        this.setState({ fileUploading, listFileNameSelected }, () => {
          this.setUploadFileState(fileUploading, "uploading");
          this.onUploadChunkFile();
        });
      },
    );
  };

  onGetBatchUploadingResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(
        `${convertReportName(
          this.state.reportName,
        )} | Request to get batch response`,
      );
      Http.getBatchResult(
        this.state.reportDate,
        convertReportName(this.state.reportName),
      ).then((res) => {
        if (res) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            console.warn(
              `${convertReportName(
                this.state.reportName,
              )} | Received state: PendingBatchProcessing`,
            );
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchUploadInterval(
              convertReportName(this.state.reportName),
            );
            console.warn(
              `${convertReportName(
                this.state.reportName,
              )} | Received state: BatchEmpty`,
            );
          } else {
            console.warn(
              `${convertReportName(
                this.state.reportName,
              )} | Received state: Success`,
            );
            this.handleUploadFileResponse(res);
          }
        }
      });
    }, 3000);
    lstInterval.push(intervalId);
  };

  onValidate = () => {
    const errors = [];

    if (!this.state.fileExtension) {
      errors.push("You must choose a file extension before upload.");
    }
    if (this.state.totalFiles === 0) {
      errors.push("You must select least 1 file.");
    }

    if (!this.state.reportName) {
      errors.push("You must enter value for Report Name.");
    }

    if (
      this.state.reportName &&
      !new RegExp("^[A-Za-z0-9_]+$").test(this.state.reportName)
    ) {
      errors.push("Report Name: allow only (a-z, A-Z, 0-9, _)");
    }

    if (!this.state.reportDate) {
      errors.push("You must enter value for Report Date.");
    }

    if (
      this.state.fileExtension === FileExtension.XLSX &&
      this.state.totalFiles > 1
    ) {
      errors.push("XLSX format only supports uploading 1 file per report.");
    }

    if (
      this.state.fileExtension !== FileExtension.XLSX &&
      this.state.totalFiles < 2
    ) {
      errors.push("CSV/TXT format should include multiple split files.");
    }

    const expectedExt = `${this.state.fileExtension || ""}`.toLowerCase();
    const invalidFiles = (this.state.listFileNameSelected || []).filter(
      (fileName) => {
        const ext = `${fileName}`.split(".").pop().toLowerCase();
        return ext !== expectedExt;
      },
    );
    if (invalidFiles.length > 0) {
      errors.push(
        `Detected file(s) not matching .${expectedExt}: ${invalidFiles.join(", ")}`,
      );
    }

    const seen = {};
    const duplicateFiles = [];
    (this.state.listFileNameSelected || []).forEach((name) => {
      const lower = `${name}`.toLowerCase();
      if (seen[lower]) {
        duplicateFiles.push(name);
      }
      seen[lower] = true;
    });
    if (duplicateFiles.length > 0) {
      errors.push(`Duplicate files selected: ${duplicateFiles.join(", ")}`);
    }

    if (errors.length > 0) {
      this.setState({ validateErrors: errors });
      Business.showAlert({
        title: "Error",
        content: errors[0],
      });
      return false;
    }

    this.setState({ validateErrors: [] });
    return true;
  };

  onUploadFileOnly = async () => {
    const isCalculating = await Business.hasBatchCalculating();
    if (isCalculating) {
      Business.showAlert({
        title: "Error",
        content: "The system is busy. Please try again in a few moments.",
      });
      return;
    }
    if (this.onValidate()) {
      this.setState({ isUploadOnly: true }, this.onUploadFile);
    }
  };

  onUploadFileAndMergeData = () => {
    if (this.onValidate()) {
      this.setState({ isUploadAndMerge: true }, this.onUploadFile);
    }
  };

  setFileExtensionSelected = (fileExtension) => {
    if (this.state.fileExtension != fileExtension) {
      this.setState({
        fileExtension,
        isMultipleFile: fileExtension != FileExtension.XLSX,
        fileAccept: `.${fileExtension}, ${this.fileAccept}`,
        file: null,
      });
    }
  };

  handleUploadFileResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
      clearGetBatchUploadInterval(convertReportName(this.state.reportName));
    }
    if (res && res.Success) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        // console.warn('Received state: PendingBatchProcessing');
      } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
        // console.warn('Received state: BatchEmpty');
      } else if (res.ErrorCode === ErrorCode.UploadOnlySuccessful) {
        this.setState(
          {
            progressValue: 0,
            isUploadOnly: false,
            isUploadAndMerge: false,
            isCalculateOnly: false,
            isUploadOnlySuccessful: true,
            isUploadAndMergeSuccessful: false,
          },
          this.startValidationStage,
        );
      } else if (res.ErrorCode === ErrorCode.UploadAndMergeSuccessful) {
        this.setState(
          {
            progressValue: 0,
            isUploadOnly: false,
            isUploadAndMerge: false,
            isCalculateOnly: false,
            isUploadOnlySuccessful: false,
            isUploadAndMergeSuccessful: true,
          },
          this.startValidationStage,
        );
      } else {
        const data = res.Data || {};
        this.setState({
          singleResult: data.SingleResult,
          consolResult: data.ConsolResult,
          progressValue: 0,
          hasResult: true,
          isUploadOnly: false,
          isUploadAndMerge: false,
          isCalculateOnly: false,
          isUploadOnlySuccessful: false,
          isUploadAndMergeSuccessful: false,
        });
      }
    } else {
      if (res) {
        switch (res.ErrorCode) {
          case ErrorCode.PermissionDenie:
            Business.showAlert({
              title: "Error",
              content: "You are not permission",
            });
            break;
          case ErrorCode.Empty:
            Business.showAlert({
              title: "Error",
              content: "File is empty",
            });
            break;
          case ErrorCode.Exist:
            Business.showAlert({
              title: "Error",
              content: "Name already exists in the system",
            });
            break;
          case ErrorCode.DataInvalid:
            Business.showAlert({
              title: "Error",
              content: res.Data,
            });
            break;
          case ErrorCode.FileInvalid:
            this.setState({
              validateErrors: [
                Array.isArray(res.Data)
                  ? `Detected ${res.Data.length} validation issues in uploaded files.`
                  : res.Data || "Uploaded file is invalid.",
              ],
            });
            break;
          case ErrorCode.UnknowError:
            Business.showAlert({
              title: "Error",
              content: res.Data || "System Error",
            });
            break;
          default:
            break;
        }
      } else {
        Business.showAlert({
          title: "Error",
          content: "Unknow Error",
        });
      }
      this.setState({
        progressValue: 0,
        isUploadOnly: false,
        isUploadAndMerge: false,
        isCalculateOnly: false,
        isUploadOnlySuccessful: false,
        isUploadAndMergeSuccessful: false,
        currentStage: "idle",
      });
    }
  };

  renderUploadChecklist = () => {
    if (
      !this.state.allSelectedFiles ||
      this.state.allSelectedFiles.length === 0
    )
      return null;

    const statusStyle = {
      pending: { icon: "○", color: "#8c8c8c", label: "Pending" },
      uploading: { icon: "◔", color: "#1677ff", label: "Uploading" },
      uploaded: { icon: "✓", color: "#389e0d", label: "Uploaded" },
    };

    return (
      <div
        style={{
          marginTop: 16,
          border: "1px solid #f0f0f0",
          borderRadius: 8,
          padding: 12,
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Uploaded Files</div>
        <div style={{ maxHeight: 180, overflowY: "auto" }}>
          {this.state.allSelectedFiles.map((fileName) => {
            const s = this.state.uploadFileStates[fileName] || "pending";
            const ui = statusStyle[s] || statusStyle.pending;
            return (
              <div
                key={fileName}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "6px 4px",
                  borderBottom: "1px dashed #f3f3f3",
                }}
              >
                <span style={{ color: "#595959" }}>{fileName}</span>
                <span style={{ color: ui.color, fontWeight: 600 }}>
                  {ui.icon} {ui.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderAutoValidationProgress = () => {
    if (
      this.state.currentStage !== "validating" &&
      this.state.currentStage !== "validated"
    ) {
      return null;
    }

    const ringRadius = 45;
    const ringCircumference = 2 * Math.PI * ringRadius;
    const ringOffset =
      ringCircumference -
      (this.state.validationProgress / 100) * ringCircumference;

    return (
      <div
        style={{
          marginTop: 16,
          border: "1px solid #e6f4ff",
          borderRadius: 8,
          padding: 12,
          background: "#f0f9ff",
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 8 }}>
          {this.state.currentStage === "validated"
            ? "Validation completed"
            : "Validating uploaded files..."}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              width: 110,
              height: 110,
              position: "relative",
              flexShrink: 0,
            }}
          >
            <svg
              width="110"
              height="110"
              viewBox="0 0 110 110"
              style={{ transform: "rotate(-90deg)" }}
            >
              <circle
                cx="55"
                cy="55"
                r={ringRadius}
                stroke="#d9e9ff"
                strokeWidth="10"
                fill="none"
              />
              <circle
                cx="55"
                cy="55"
                r={ringRadius}
                stroke={
                  this.state.currentStage === "validated"
                    ? "#389e0d"
                    : "#1677ff"
                }
                strokeWidth="10"
                strokeLinecap="round"
                fill="none"
                strokeDasharray={ringCircumference}
                strokeDashoffset={ringOffset}
                style={{ transition: "stroke-dashoffset .25s linear" }}
              />
            </svg>
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                color: "#1f1f1f",
              }}
            >
              {this.state.validationProgress}%
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <ProgressBar
              striped
              now={this.state.validationProgress}
              label={`${this.state.validationProgress}%`}
            />
          </div>
        </div>
        {this.state.currentStage === "validated" && (
          <div style={{ marginTop: 8, color: "#389e0d", fontWeight: 600 }}>
            All uploaded files are ready. Redirecting to file management in{" "}
            {this.state.autoNavigateCountdown || 0}s...
          </div>
        )}
      </div>
    );
  };

  renderValidationSummary = () => {
    const { validateErrors } = this.state;
    if (!validateErrors || validateErrors.length === 0) return null;

    return (
      <div
        style={{
          border: "1px solid #ffd8bf",
          backgroundColor: "#fff7e6",
          borderRadius: 8,
          padding: 12,
          marginTop: 16,
        }}
      >
        <div style={{ fontWeight: 600, color: "#ad4e00", marginBottom: 6 }}>
          Validation summary
        </div>
        <ul style={{ margin: 0, paddingLeft: 20, color: "#8c4a00" }}>
          {validateErrors.map((error, index) => (
            <li key={`validation-error-${index}`}>{error}</li>
          ))}
        </ul>
      </div>
    );
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
            }}
            className="title"
          >
            The system is processing the uploaded file. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderProgress = () => {
    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <div className="content text-center">
              <ProgressBar
                striped
                now={this.state.progressValue}
                label={`Upload ${this.state.progressValue.toFixed(3)}%`}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderUploadOnlySuccessful = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
            }}
            className="title"
          >
            Upload successful
          </h4>
        </div>
      </div>
    );
  };

  renderUploadAndMegeSuccessful = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
            }}
            className="title"
          >
            Upload and merge data successfully
          </h4>
        </div>
      </div>
    );
  };

  handleSelectSingleConsolMethod = (eventKey, event) => {
    this.setState({ singleConsol: eventKey });
  };

  onDownloadSample = () => {
    return Http.downloadSampleFile(
      `${Business.COMPONENT.NSFR.toUpperCase()}.zip`,
      "sample",
      Business.COMPONENT.NSFR,
    );
  };

  render() {
    return (
      // Business.isHasRole([Business.ROLE_DEFINE_MAP.RAROC_UPLOAD_FILES]) && (
      <div className="card upload-form-animated">
        <div className="header" style={{ gap: 16 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              color: "#757575",
              fontSize: 16,
            }}
          >
            <p style={{ marginBottom: 0 }}>LIQUIDITY RATIO</p>
            <p style={{ marginBottom: 0 }}>/</p>
            <p style={{ marginBottom: 0 }}>NSFR</p>
            <p style={{ marginBottom: 0 }}>/</p>
            <p style={{ color: "#BF6A02", marginBottom: 0 }}>Upload file</p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h4 className="title" style={{ fontSize: 20 }}>
              Upload file
            </h4>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginTop: 6,
            }}
          >
            <span
              style={{
                padding: "6px 10px",
                borderRadius: 999,
                background: "#fff6d6",
                color: "#8c6d1f",
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              1. Upload
            </span>
            <span style={{ color: "#bfbfbf" }}>→</span>
            <span
              style={{
                padding: "6px 10px",
                borderRadius: 999,
                background: "#e6f7ff",
                color: "#096dd9",
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              2. Validate
            </span>
            <span style={{ color: "#bfbfbf" }}>→</span>
            <span
              style={{
                padding: "6px 10px",
                borderRadius: 999,
                background: "#f6ffed",
                color: "#389e0d",
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              3. Approve / Calculate
            </span>
          </div>
        </div>
        <div style={{ height: 6 }} />
        <div
          className="content table-responsive table-full-width"
          style={{ paddingBottom: "0px !important" }}
        >
          <div className="upload-two-col">
            <div className="upload-two-col__left">
              <form className="upload-layout-order">
                <div
                  className="upload-report-row"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 16,
                  }}
                >
                  <div className="form-group" style={{ flex: 1 }}>
                    <label
                      htmlFor="exampleInputEmail1"
                      style={{ fontSize: 16, lineHeight: "22px" }}
                    >
                      Report Name
                    </label>
                    <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
                    <input
                      type="text"
                      className="form-control"
                      id="reportname"
                      onChange={(event) => {
                        this.setState({ reportName: event.target.value });
                      }}
                      required={true}
                      style={{
                        border: "1px solid #D9D9D9",
                        backgroundColor: "#FFFFFF",
                        borderRadius: 8,
                        height: 44,
                      }}
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label
                      htmlFor="exampleInputEmail12"
                      style={{ fontSize: 16, lineHeight: "22px" }}
                    >
                      Report Date
                    </label>
                    <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
                    <input
                      type="date"
                      className="form-control"
                      id="reportDate"
                      min="2010-01-01"
                      max={moment(new Date(), "YYYY-MM-DD").format(
                        "YYYY-MM-DD",
                      )}
                      placeholder="MM/DD/YYYY"
                      required={true}
                      value={this.state.reportDate}
                      onChange={(event) => {
                        this.setState({ reportDate: event.target.value });
                      }}
                      style={{
                        border: "1px solid #D9D9D9",
                        backgroundColor: "#FFFFFF",
                        borderRadius: 8,
                        height: 44,
                      }}
                    />
                  </div>
                </div>
                <div
                  className="upload-format-row"
                  style={{ display: "flex", alignItems: "center", gap: 32 }}
                >
                  <p
                    style={{
                      marginBottom: 15,
                      fontSize: 16,
                      lineHeight: "22px",
                    }}
                  >
                    File format:
                  </p>
                  <div className="form-group row">
                    <div
                      className="col-md-6 checkbox-group"
                      style={{ display: "flex" }}
                    >
                      {["XLSX", "CSV", "TXT"].map((fileExtension, index) => (
                        <div
                          key={index}
                          style={{
                            display: "inline-block",
                            marginRight: "30px",
                          }}
                          onClick={() =>
                            this.setFileExtensionSelected(fileExtension)
                          }
                        >
                          <Field
                            name="radioGroup"
                            type="radio"
                            label={`.${fileExtension}`}
                            value={fileExtension}
                            checked={this.state.fileExtension === fileExtension}
                            component={renderField}
                          />
                        </div>
                      ))}
                    </div>
                    <div
                      className="col-md-6"
                      style={{ textAlign: "right", padding: "10px" }}
                    >
                      {/* <label>Ngày 31/12/2022 đang tồn tại bản ghi Chờ phê duyệt</label> */}
                    </div>
                  </div>
                </div>
                <div className="form-group upload-file-row">
                  <label
                    htmlFor="exampleFormControlFile1"
                    style={{ fontSize: 16, lineHeight: "22px" }}
                  >
                    Upload data file
                  </label>
                  <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
                  <div
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (this.state.progressValue === 0) {
                        this.setState({ isDragging: true });
                      }
                    }}
                    onDragEnter={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (this.state.progressValue === 0) {
                        this.setState({ isDragging: true });
                      }
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.setState({ isDragging: false });
                    }}
                    onDrop={this.onDrop}
                    onClick={() => {
                      if (this.state.progressValue === 0) {
                        document.getElementById("chooseFile").click();
                      }
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: this.state.isDragging
                        ? "2px dashed #FFE600"
                        : "1px dashed #bbb",
                      borderRadius: 8,
                      padding: "10px 14px",
                      background: this.state.isDragging ? "#fffef0" : "#fafafa",
                      gap: 10,
                      cursor:
                        this.state.progressValue > 0
                          ? "not-allowed"
                          : "pointer",
                      transition: "border 0.15s, background 0.15s",
                    }}
                  >
                    <i
                      className="pe-7s-upload"
                      style={{
                        fontSize: 22,
                        color: this.state.isDragging ? "#FFE600" : "#1a1a3e",
                        transition: "color 0.15s",
                      }}
                    />
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          fontSize: 13,
                          color:
                            this.state.noFileVal === "No file chosen..."
                              ? "#aaa"
                              : "#1E1E1E",
                          fontWeight:
                            this.state.noFileVal === "No file chosen..."
                              ? 400
                              : 600,
                        }}
                      >
                        {this.state.isDragging
                          ? "Thả file vào đây..."
                          : this.state.noFileVal}
                      </div>
                      <div
                        style={{ fontSize: 11, color: "#888", marginTop: 2 }}
                      >
                        {this.state.fileExtension === FileExtension.CSV
                          ? "Kéo thả hoặc click để chọn nhiều file CSV (Ctrl+A để chọn tất cả)"
                          : "Kéo thả hoặc click để chọn file"}
                      </div>
                    </div>
                    <label
                      htmlFor="chooseFile"
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        margin: 0,
                        padding: "6px 14px",
                        borderRadius: 6,
                        background:
                          this.state.progressValue > 0 ? "#eee" : "#FFE600",
                        color:
                          this.state.progressValue > 0 ? "#aaa" : "#1a1a3e",
                        fontSize: 12,
                        fontWeight: 600,
                        cursor:
                          this.state.progressValue > 0
                            ? "not-allowed"
                            : "pointer",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Chọn file
                    </label>
                    <input
                      type="file"
                      multiple={this.state.isMultipleFile}
                      name="chooseFile"
                      id="chooseFile"
                      disabled={this.state.progressValue > 0}
                      accept={this.state.fileAccept}
                      onChange={(e) => this.onChangeFile(e)}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="upload-two-col__right">
              <UploadSelectedFilesPanel
                selectedFiles={this.state.listFileNameSelected}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 16,
              marginTop: 17,
            }}
          >
            <button
              type="submit"
              disabled={this.state.progressValue > 0}
              className="btn btn-primary upload-btn-modern"
              style={{
                backgroundColor: "#2C2C2C",
                borderColor: "#2C2C2C",
                borderRadius: "8px",
                fontSize: 16,
                lineHeight: 1,
                color: "#F5F5F5",
                height: 44,
              }}
              onClick={() => this.onUploadFileOnly()}
            >
              Upload
            </button>
          </div>
          {this.renderValidationSummary()}
          {this.renderUploadChecklist()}
          {this.renderAutoValidationProgress()}
        </div>

        <div style={{ height: 30 }} />
        {this.state.progressValue > 0 && this.renderProgress()}
        {this.state.isUploadOnlySuccessful &&
          this.state.errorCode !== ErrorCode.PendingBatchProcessing &&
          this.renderUploadOnlySuccessful()}
        {this.state.isUploadAndMergeSuccessful &&
          this.state.errorCode !== ErrorCode.PendingBatchProcessing &&
          this.renderUploadAndMegeSuccessful()}
        {this.state.errorCode === ErrorCode.PendingBatchProcessing &&
          this.renderPendingBatchProcessing()}
      </div>
      // )
    );
  }
}

export default reduxForm({
  form: "UploadFile",
})(UploadFile);



// WEBPACK FOOTER //
// src/pages/LiquidityRatio/NFSR/UploadFile.js